import { IEvent } from '@studyportals/event-aggregation-service-interface';

export class ClearLocationFilterEvent implements IEvent {
	public static readonly EventType = 'SearchFilters:ClearLocationFilterEvent';

	public readonly timestamp = new Date();
	public readonly eventType = ClearLocationFilterEvent.EventType;

	public static is(event: IEvent): event is ClearLocationFilterEvent {
		return event.eventType === ClearLocationFilterEvent.EventType;
	}
}
